import React, { FC, useEffect } from 'react';
import { Link, RouteObject } from 'react-router-dom';
import { BhabiWordmark } from './bhabi-wordmark';

export const PageNotFound: FC = () => {
  useEffect(() => {
    document.title = 'Page not found · Bhabi';
  }, []);

  return (
    <div className="bh-state">
      <div className="bh-state__inner">
        <BhabiWordmark />
        <div className="bh-mini-fan" aria-hidden="true">
          <span>?</span>
          <span data-red="true">♥</span>
          <span>♣</span>
          <span data-red="true">♦</span>
        </div>
        <h1 className="bh-h2">This seat is empty.</h1>
        <p className="bh-lead">
          The page you were looking for isn&apos;t at this table any more.
        </p>
        <Link to="/" className="bh-btn bh-btn--primary">
          Back home
        </Link>
      </div>
    </div>
  );
};

export const notFoundRoute: RouteObject = {
  path: '*',
  element: <PageNotFound />,
};
